<template>
  <div class="item__item">
    <div class="item__main">
      <router-link :to="{name: 'Detail', params: {id: item.id}}" class="item__image">
        <img :src="partsStore.imagePath + '/' + item.image" alt="part image" v-if="item.image">
        <img src="../assets/partnumbersearch-placeholder-products.jpg" alt="part image" v-else/>
        <div class="image__meta">
          <span class="meta__meta">{{ item.type }}</span>
        </div>
      </router-link>
      <div class="item__content">
        <div class="content__meta">
          <router-link :to="'/show/' + item.id" class="meta__id" v-if="!item.hidePartNo || item.express">
            <span class="item-id bold meta" v-if="!item.hidePartNo">{{item.id}}</span>
            <img src="../assets/express.jpeg" height="23" width="100" alt="express" v-if="item.express"/>
          </router-link>
          <router-link :to="'/show/' + item.id" class="content__description" v-else>
            <div class="description__description">
              <span class="description__series"><template v-for="(serie, key) in item.series" :key="key">{{serie}} <template v-if="(key + 1) < item.series.length">, </template></template></span>
              <span class="heading espilon -color-text-alpha">{{item.description}}</span>
            </div>
          </router-link>
          <div class="item__hint" v-if="showHint">
            <span>{{ $t('list.saved') }}</span>
          </div>
          <div class="meta__link" @click="handleAddToCart()" v-if="!cartStore.itemInCart(item)">
            <span class="bold meta -color-text-alpha icon-cart-alternative-before">{{ $t('list.addToCart') }}</span>
          </div>
        </div>
        <router-link :to="'/show/' + item.id" class="content__description" v-if="!item.hidePartNo || item.express">
          <div class="description__description">
            <span class="description__series"><template v-for="(serie, key) in item.series" :key="key">{{serie}} <template v-if="(key + 1) < item.series.length">, </template></template></span>
            <span class="heading espilon -color-text-alpha">{{item.description}}</span>
          </div>
        </router-link>
      </div>
    </div>
    <router-link :to="'/show/' + item.id" class="item__bottom" v-if="filterArray.length">
      <div class="bottom__filter">
        <div class="item__filter" v-for="(item, key) in filterArray" :key="key">
          <span class="filter-icon">
            <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="09-ODU-Rework" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="ODU-Rework-Trendlayout-00-02-BP3-Partnumber-Search-2.0-VAR-01" transform="translate(-459.000000, -540.000000)">
                      <g id="bp3-/-mod_content-/-list" transform="translate(0.000000, 290.000000)">
                          <g id="bp3-/-mod_search-/-list" transform="translate(434.000000, 103.000000)">
                              <g id="Group-14" transform="translate(0.000000, 134.000000)">
                                  <g id="Group-15" transform="translate(25.500000, 10.000000)">
                                      <g id="Group-2" transform="translate(0.000000, 3.000000)">
                                          <circle id="Oval" fill="#0076A6" cx="8" cy="8" r="8"></circle>
                                          <polyline id="Path-2-Copy" stroke="#FFFFFF" stroke-width="2" points="4 7.5 6.58394558 10 12 5"></polyline>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
          </span>
          <span class="bold -color-text-alpha meta">{{item.labelBefore}} {{item.value}} {{item.labelAfter}}</span>
        </div>
        <div class="item__filter--placeholder" v-if="filterArray.length < 4"></div>
        <div class="item__filter--placeholder" v-if="filterArray.length < 3"></div>
        <div class="item__filter--placeholder" v-if="filterArray.length < 2"></div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue'

import { usePartsStore } from '@/stores/parts'
import {useCartStore} from '@/stores/cart';
import {useRouter} from 'vue-router';
import {useCableConfiguratorStore} from '@/stores/cableConfigurator';
import {i18n} from '@/plugins/i18n';

const prop = defineProps({
  item: {
    type: Object,
    default: null
  }
})

const partsStore = usePartsStore()
const cartStore = useCartStore()
const cableConfigurationStore = useCableConfiguratorStore()
const router = useRouter()

const filterArray = []

const showHint = ref(false)
if (prop.item.size)
{
  filterArray.push({
    value: prop.item.size,
    labelBefore: i18n.global.t('list.size')
  })
}

if (prop.item.degreeOfProtection)
{
  filterArray.push({
    value: prop.item.degreeOfProtection
  })
}
if (prop.item.numberOfContacts)
{
  filterArray.push({
    value: prop.item.numberOfContacts,
    labelAfter: i18n.global.t('list.contacts')
  })
}
if (prop.item.keying)
{
  filterArray.push({
    value: prop.item.keying,
    labelAfter: i18n.global.t('list.keying')
  })
}
if (prop.item.operatingVoltage60664 && filterArray.length < 4)
{
  filterArray.push({
    value: prop.item.operatingVoltage60664,
    labelBefore: i18n.global.t('list.operatingvoltage60664')
  })
}
if (prop.item.maxCurrAwg && filterArray.length < 4)
{
  filterArray.push({
    value: prop.item.maxCurrAwg,
    labelBefore: i18n.global.t('list.maxCurrAwg')
  })
}
if (prop.item.ratSurge && filterArray.length < 4)
{
  filterArray.push({
    value: prop.item.ratSurge,
    labelBefore: i18n.global.t('list.ratSurge')
  })
}
if (prop.item.frequencyRange && filterArray.length < 4)
{
  filterArray.push({
    value: prop.item.frequencyRange,
    labelBefore: i18n.global.t('list.frequencyRange')
  })
}

function handleAddToCart ()
{
  if (cartStore.openedFirstTime) {
    showHint.value = true
    setTimeout(() =>
    {
      showHint.value = false
    }, 2000)
  }
  if (prop.item.typeKey === 'cable_assembly' && prop.item.assemblyId)
  {
    cableConfigurationStore.showOverlay = true
    cableConfigurationStore.scrollToCableConfi = true
    router.push({
      path: '/show/' + prop.item.id
    })
  } else if (prop.item.typeKey === 'cable_assembly') {
    cartStore.addToCart(prop.item, true)
  } else {
    cartStore.addToCart(prop.item)
  }


}
</script>

